import './bootstrap';
import MetisMenu from 'metismenu';
import 'startbootstrap-sb-admin-2/js/sb-admin-2';
import './admin/ajax-form';
import './admin/scripts';
import './admin/destroy-confirmation';
import './admin/download-language-modal';
import 'livewire-sortable';

import Toastr from 'toastr';
window.toastr = Toastr;

import DataTable from 'datatables.net-bs4';
import languageDE from 'datatables.net-plugins/i18n/de-DE.mjs';
import languageEN from 'datatables.net-plugins/i18n/en-GB.mjs';
import languageFR from 'datatables.net-plugins/i18n/fr-FR.mjs';
import languageNL from 'datatables.net-plugins/i18n/nl-NL.mjs';
import languageCS from 'datatables.net-plugins/i18n/cs.mjs';
import languageRO from 'datatables.net-plugins/i18n/ro.mjs';
import languageSV from 'datatables.net-plugins/i18n/sv-SE.mjs';
import languageSR from 'datatables.net-plugins/i18n/sr.mjs';
window.datatablesLanguageDE = languageDE;
window.datatablesLanguageEN = languageEN;
window.datatablesLanguageFR = languageFR;
window.datatablesLanguageNL = languageNL;
window.datatablesLanguageCZ = languageCS;
window.datatablesLanguageRO = languageRO;
window.datatablesLanguageSE = languageSV;
window.datatablesLanguageSR = languageSR;

import select2 from 'select2/dist/js/select2.full';
import select2LanguageDE from 'select2/dist/js/i18n/de';
import select2LanguageEN from 'select2/dist/js/i18n/en';
import select2LanguageFR from 'select2/dist/js/i18n/fr';
import select2LanguageNL from 'select2/dist/js/i18n/nl';
import select2LanguageCS from 'select2/dist/js/i18n/cs';
import select2LanguageRO from 'select2/dist/js/i18n/ro';
import select2LanguageSV from 'select2/dist/js/i18n/sv';
import select2LanguageSR from 'select2/dist/js/i18n/sr';
window.select2LanguageDE = select2LanguageDE;
window.select2LanguageEN = select2LanguageEN;
window.select2LanguageFR = select2LanguageFR;
window.select2LanguageNL = select2LanguageNL;
window.select2LanguageCZ = select2LanguageCS;
window.select2LanguageRO = select2LanguageRO;
window.select2LanguageSE = select2LanguageSV;
window.select2LanguageSR = select2LanguageSR;

import Raphael from 'raphael';
window.Raphael = Raphael;
import 'morris.js/morris';
import './admin/custom.js';

import './admin/plugins-jquery';
import './admin/morris.init';
import './admin/datepicker';

import 'bootstrap-fileinput';
import 'bootstrap-fileinput/themes/fa/theme';

import 'summernote';
import 'summernote/lang/summernote-de-DE';

import 'bootstrap-select';
